import {DataTransferObjectValidation} from "../../../../type/Types";
import {PlacePathFileValueObject} from "../../../vo/content/place/PlacePathFileValueObject";

export namespace PlacePathFileDataTransferObject {
    export type Post = {
        placePathId: bigint
        orderNumber: number
        fileName: string | null
        fileUrl: string | null
    }
    
    export namespace Post {
        export const description: Record<keyof Post, string> = PlacePathFileValueObject.description
        
        export const validation: DataTransferObjectValidation<Post> = {
            placePathId(o: string): bigint | Error {
                return DataTransferObjectValidation.transformBigInt(o, 'placePathId')
            },
            orderNumber(o: string): number | Error {
                return DataTransferObjectValidation.transformNumber(o, 'orderNumber')
            },
            fileName(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'fileName')
            },
            fileUrl(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'fileUrl')
            }
        }
    }
    
    export type Put = {
        placePathId: bigint
        orderNumber: number
        fileName: string | null
        fileUrl: string | null
    }
    
    export namespace Put {
        export const description: Record<keyof Put, string> = PlacePathFileValueObject.description
        
        export const validation: DataTransferObjectValidation<Put> = {
            placePathId(o: string): bigint | Error {
                return DataTransferObjectValidation.transformBigInt(o, 'placePathId')
            },
            orderNumber(o: string): number | Error {
                return DataTransferObjectValidation.transformNumber(o, 'orderNumber')
            },
            fileName(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'fileName')
            },
            fileUrl(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'fileUrl')
            }
        }
    }
    
    export type PatchFile = {
        fileUrl: string | null
    }
    
    export namespace PatchFile {
        export const description: Record<keyof PatchFile, string> = PlacePathFileValueObject.description
        
        export const validation: DataTransferObjectValidation<PatchFile> = {
            fileUrl(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'fileUrl')
            }
        }
    }
}